import React from 'react';
import { motion } from 'framer-motion';

interface NavbarProps {
  navItems?: { label: string; href: string }[];
  logo?: string;
}

const Navbar: React.FC<NavbarProps> = ({ navItems = [], logo = '光眠' }) => {
  return (
    <motion.header
      className="bg-white/50 backdrop-blur-xl dark:bg-gray-800 fixed top-0 left-0 right-0 w-full z-50"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        type: 'spring',
        stiffness: 100,
        damping: 20,
        mass: 1,
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-12">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a
              href="/"
              className="text-xl md:text-xl font-sawarabi font-bold text-l-text-1 dark:text-white hover:text-blue-600 hover:scale-105 transition-all duration-300 ease-in-out"
            >
              {logo}
            </a>
          </div>

          {/* Navigation Links */}
          {navItems.length > 0 && (
            <nav className="hidden md:flex space-x-8 flex-1 justify-center">
              {navItems.map(item => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-gray-700 dark:text-gray-300 px-3 py-2 text-sm font-medium hover:text-blue-600 hover:scale-105 transition-all duration-300 ease-in-out"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          )}
        </div>
      </div>
    </motion.header>
  );
};

export default Navbar;
